// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChartFilterController from "./chart_filter_controller"
application.register("chart-filter", ChartFilterController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DateNumberController from "./date_number_controller"
application.register("date-number", DateNumberController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import FetchOnVisibleController from "./fetch_on_visible_controller"
application.register("fetch-on-visible", FetchOnVisibleController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FlatpickrModalController from "./flatpickr_modal_controller"
application.register("flatpickr-modal", FlatpickrModalController)

import FormController from "./form_controller"
application.register("form", FormController)

import PasswordModalController from "./password_modal_controller"
application.register("password-modal", PasswordModalController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import ProvinceSelectorController from "./province_selector_controller"
application.register("province-selector", ProvinceSelectorController)

import TableController from "./table_controller"
application.register("table", TableController)

import TimeSliderController from "./time_slider_controller"
application.register("time-slider", TimeSliderController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import VerificationCodeController from "./verification_code_controller"
application.register("verification-code", VerificationCodeController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)
